import React from 'react';
import { Box, Typography, Link, Container } from '@mui/material';
import colors from '../theme/colors';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: 'auto',
        backgroundColor: colors.background.paper,
        borderTop: `1px solid ${colors.border.main}`,
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 2,
          }}
        >
          <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.8rem' }}>
            © {currentYear} Hive Identity Service. All rights reserved.
          </Typography>
          
          <Box sx={{ display: 'flex', gap: 3 }}>
            <Link
              href="#"
              underline="hover"
              color="text.secondary"
              sx={{ fontSize: '0.8rem', '&:hover': { color: colors.primary.main } }}
            >
              Privacy Policy
            </Link>
            <Link
              href="#"
              underline="hover"
              color="text.secondary"
              sx={{ fontSize: '0.8rem', '&:hover': { color: colors.primary.main } }}
            >
              Terms of Service
            </Link>
            <Link
              href="#"
              underline="hover"
              color="text.secondary"
              sx={{ fontSize: '0.8rem', '&:hover': { color: colors.primary.main } }}
            >
              Contact
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;
